import { RightOutlined } from '@ant-design/icons';
import { setCurrentOrg } from 'app-redux/actions/org.actions';
import { AppState } from 'app-redux/reducers';
import { INavigationRouteProps } from 'core/navigation/models';
import { UUID } from 'core/utils/BasicModels';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SegmentService } from 'services/SegmentService';
import { Typography } from 'syngenta-digital-cropwise-react-ui-kit';
import { translationWrapper } from 'utils/common-methods';
import './style.less';

interface IOrgCardProps extends INavigationRouteProps<{}> {
  id: string;
  name: string;
  setCurrentOrg?: (orgId: UUID) => Promise<void>;
}

const { Text } = Typography;

const OrgCard: React.FC<IOrgCardProps> = (props) => {

  const { t } = translationWrapper(useTranslation(), false);
  const handleOrgCardClick = async (orgId: string) => {
    SegmentService().track(t('Home page - Tap to open an organization'));
    if (props.setCurrentOrg) {
      await props.setCurrentOrg(orgId);
    }
  };

  return (
    <div onClick={() => handleOrgCardClick(props.id)} className={'cw-org-card'}>
        <div className={'cw-org-placeholder'}>
          <div className={'cw-org-rectangle'}/>
          <div className={'cw-org-arrow'}>
                <RightOutlined style={{ fontSize: '12px' }}/>
          </div>
          <div className={'cw-org-name'}>
              <Text strong={true} style={{ fontSize: '16px', color: '#363948' }}>{props.name}</Text>
          </div>
        </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: any) => {
  return {
    setCurrentOrg: (orgId: UUID) => dispatch(setCurrentOrg(orgId)),
  };
};

export const OrgCardComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(OrgCard));
